module.exports = __webpack_public_path__ + "img/underline.ae1cb7a6.svg";